import { SupportSendMessageRequest } from '@common/model/support/message.request';
import { coreApi } from '@cp/shared/api/core';

export const coreSupportApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessageToSupport: builder.mutation<void, SupportSendMessageRequest & { attachments: FileList | null }>({
      query: ({ attachments, ...restParams }) => {
        const formData = new FormData();

        if (attachments?.length) {
          for (const attachment of attachments) {
            formData.append('attachments', attachment);
          }
        }

        for (const paramName in restParams) {
          formData.append(paramName, restParams[paramName as keyof typeof restParams]);
        }

        return {
          url: '/support/message',
          body: formData,
          method: 'POST',
        };
      },
    }),
  }),

  overrideExisting: false,
});
